import getFieldValue from 'foundation/js/stafet/getFieldValue'
import { globalFetch } from 'foundation/js/api'
import store from '../index.js'

export default {
    namespaced: true,
    state: {
        isSubmitting: false,
        stafetId: '',
        teams: [],
        totalNumberOfTeams: 0,
        userInputs: [],
        steps: [],
        currentStep: 1,
        basket: [],
        basketTotalPrice: 0,
        previousTeams: null,
        teamLights: [],
        teamLightsTotal: 0,
        teamDonations: [],
        teamDonationsTotal: 0,
        teamParticipantDetails: [],
        teamDonationsPaginated: [],
        teamDonationsPaginatedTotalHits: 0,
        teamDonationsPaginatedDonationerCount: 0,
        teamDonationsPaginatedAdmissionsCount: 0
    },
    mutations: {
        set_previous_teams(state, teamslist) {
            state.previousTeams = teamslist
        },
        set_stafet_id(state, stafetId) {
            state.stafetId = stafetId
        },
        set_teams(state, teams) {
            state.teams = teams
        },
        set_total_number_of_teams(state, totalNumberOfTeams) {
            state.totalNumberOfTeams = totalNumberOfTeams
        },
        set_user_inputs(state, inputs) {
            state.userInputs = inputs
        },
        set_steps(state, steps) {
            state.steps = steps
        },
        set_current_step(state, step) {
            state.currentStep = step
        },
        set_basket(state, basket) {
            state.basket = basket
        },
        set_basket_total_price(state, price) {
            state.basketTotalPrice = price
        },
        set_team_lights(state, teamLights) {
            state.teamLights = teamLights
        },
        set_team_lights_total(state, teamLightsTotal) {
            state.teamLightsTotal = teamLightsTotal
        },
        set_team_participant_details(state, teamParticipantDetails) {
            state.teamParticipantDetails = teamParticipantDetails
        },
        set_team_donations(state, teamDonations) {
            state.teamDonations = teamDonations
        },
        set_team_donations_total(state, teamDonationsTotal) {
            state.teamDonationsTotal = teamDonationsTotal
        },
        set_is_submitting(state, isSubmitting) {
            state.isSubmitting = isSubmitting
        },
        set_team_donations_paginated(state, teamDonationsPaginated) {
            state.teamDonationsPaginated = teamDonationsPaginated
        },
        set_team_donations_paginated_total(state, teamDonationsTotal) {
            state.teamDonationsPaginatedTotalHits = teamDonationsTotal
        },
        set_team_donations_paginated_donationer_count(state, totalDonationer) {
            state.teamDonationsPaginatedDonationerCount = totalDonationer
        },
        set_team_donations_paginated_admissions_count(state, totalAdmissions) {
            state.teamDonationsPaginatedAdmissionsCount = totalAdmissions
        }
    },
    getters: {
        teamDonationsPaginated: (state) => state.teamDonationsPaginated,
        teamDonationsPaginatedTotalHits: (state) =>
            state.teamDonationsPaginatedTotalHits,
        teamDonationsPaginatedDonationerCount: (state) =>
            state.teamDonationsPaginatedDonationerCount,
        teamDonationsPaginatedAdmissionsCount: (state) =>
            state.teamDonationsPaginatedAdmissionsCount
    },
    actions: {
        stafetId(context, config) {
            context.commit('set_stafet_id', config.stafetId)
        },
        getPreviousTeams(context) {
            const url = process.env.GET_PREVIOUS_TEAMS_LIST.replace(
                '[newStafetkode]',
                context.state.stafetId
            )
            globalFetch(url)
                .then((response) => response.json())
                .then((data) => {
                    context.commit('set_previous_teams', data.hits)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        getTeamParticipantDetails(context, config) {
            const url =
                `${document.location.origin}/${process.env.GET_STAFET_TEAM_PARTICIPANT_DETAILS}`.replace(
                    '[holdKode]',
                    config.teamId
                )
            globalFetch(url)
                .then((response) => response.json())
                .then((data) => {
                    context.commit('set_team_participant_details', data.hits)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        getTeamDonations(context, config) {
            const url =
                `${document.location.origin}/${process.env.GET_STAFET_TEAM_DONATIONS}`.replace(
                    '[holdKode]',
                    config.teamId
                )
            globalFetch(url)
                .then((response) => response.json())
                .then((data) => {
                    if (data.skip === 0) {
                        context.commit('set_team_donations', data.hits)
                    } else {
                        context.commit(
                            'set_team_donations',
                            context.state.teamDonations.concat(data.hits)
                        )
                    }
                    context.commit('set_team_donations_total', data.totalHits)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        getTeamDonationsPaginated(context, config) {
            const url =
                `${document.location.origin}/${process.env.GET_STAFET_TEAM_DONATIONS_PAGINATED}`
                    .replace(
                        '[holdKode]',
                        encodeURIComponent(config.teamId ?? '')
                    )
                    .replace(
                        '[offsetDonationer]',
                        encodeURIComponent(config.offsetDonationer ?? 0)
                    )
                    .replace(
                        '[offsetAdmissions]',
                        encodeURIComponent(config.offsetAdmissions ?? 0)
                    )
                    .replace('[limit]', encodeURIComponent(config.limit ?? 50))

            return globalFetch(url)
                .then((response) => {
                    if (!response.ok) throw new Error(`HTTP ${response.status}`)
                    return response.json()
                })
                .then((data) => {
                    const hits = Array.isArray(data.hits) ? data.hits : []
                    if (
                        (config.offsetDonationer ?? 0) === 0 &&
                        (config.offsetAdmissions ?? 0) === 0
                    ) {
                        context.commit('set_team_donations_paginated', hits)
                        context.commit(
                            'set_team_donations_paginated_donationer_count',
                            0
                        )
                        context.commit(
                            'set_team_donations_paginated_admissions_count',
                            0
                        )
                    } else {
                        context.commit(
                            'set_team_donations_paginated',
                            context.getters.teamDonationsPaginated.concat(hits)
                        )
                    }

                    context.commit(
                        'set_team_donations_paginated_total',
                        data.totalHits ?? 0
                    )

                    const pageDonationer = Number.isFinite(data.holdDonationer)
                        ? data.holdDonationer
                        : 0
                    const pageAdmissions = Number.isFinite(
                        data.deltagerDonationer
                    )
                        ? data.deltagerDonationer
                        : 0

                    const prevDonationer =
                        (config.offsetDonationer ?? 0) === 0
                            ? 0
                            : context.getters
                                  .teamDonationsPaginatedDonationerCount

                    const prevAdmissions =
                        (config.offsetAdmissions ?? 0) === 0
                            ? 0
                            : context.getters
                                  .teamDonationsPaginatedAdmissionsCount

                    context.commit(
                        'set_team_donations_paginated_donationer_count',
                        prevDonationer + pageDonationer
                    )
                    context.commit(
                        'set_team_donations_paginated_admissions_count',
                        prevAdmissions + pageAdmissions
                    )

                    const nextOffsetDonationer =
                        (config.offsetDonationer ?? 0) + pageDonationer
                    const nextOffsetAdmissions =
                        (config.offsetAdmissions ?? 0) + pageAdmissions

                    const hasMore =
                        nextOffsetDonationer + nextOffsetAdmissions <
                        (data.totalHits ?? 0)

                    return {
                        nextOffsetDonationer,
                        nextOffsetAdmissions,
                        hasMore
                    }
                })
                .catch((err) => {
                    console.error(err)
                    throw err // rethrow if callers need to handle it
                })
        },
        getTeamLights(context, config) {
            const url =
                `${document.location.origin}/${process.env.GET_STAFET_TEAM_LIGHTS}`.replace(
                    '[holdKode]',
                    config.teamId
                )
            globalFetch(url)
                .then((response) => response.json())
                .then((data) => {
                    if (data.skip === 0) {
                        context.commit('set_team_lights', data.hits)
                    } else {
                        context.commit(
                            'set_team_lights',
                            context.state.teamLights.concat(data.hits)
                        )
                    }
                    context.commit('set_team_lights_total', data.totalHits)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        teams(context, config) {
            const url =
                `${document.location.origin}/${process.env.GET_STAFET_TEAM_LIST.replace('[stafetId]', config.stafetId)}?skip=${config.skip}&take=${config.take}`.replace(
                    '[pageId]',
                    store.state.main.page_id
                )
            globalFetch(url)
                .then((response) => response.json())
                .then((data) => {
                    if (config.skip === 0) {
                        context.commit('set_teams', data.teams)
                    } else {
                        context.commit(
                            'set_teams',
                            context.state.teams.concat(data.teams)
                        )
                    }
                    context.commit('set_total_number_of_teams', data.totalHits)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        userInputs(context, config) {
            const userInputs = context.state.userInputs
            if (userInputs.length === 0) {
                context.commit('set_user_inputs', config.inputs)
            } else {
                const nonMatchingValuesList = []

                userInputs.map((item) => {
                    const match = config.inputs.find(
                        (newItem) => newItem.name === item.name
                    )
                    if (!match) {
                        nonMatchingValuesList.push(item)
                    }
                })

                context.commit('set_user_inputs', [
                    ...nonMatchingValuesList,
                    ...config.inputs
                ])
            }
        },
        steps(context, config) {
            context.commit('set_steps', config.steps)
        },
        currentStep(context, config) {
            context.commit('set_current_step', config.step)
        },
        basket(context, config) {
            const basket = context.state.basket
            let updatedBasket = []
            if (basket.length === 0) {
                updatedBasket = config.basket
            } else {
                const nonMatchingValuesList = []

                basket.map((item) => {
                    const match = config.basket.find(
                        (newItem) => newItem.name === item.name
                    )
                    if (!match) {
                        nonMatchingValuesList.push(item)
                    }
                })

                updatedBasket = [...nonMatchingValuesList, ...config.basket]
            }

            context.commit('set_basket', updatedBasket)
            let totalPrice = 0
            updatedBasket.map((item) => {
                totalPrice += item.intPrice
            })
            context.commit('set_basket_total_price', totalPrice)
        },
        basketTotalPrice(context, config) {
            context.commit('set_basket_total_price', config.price)
        },
        joinATeamSubmit(context) {
            const url =
                `${document.location.origin}/${process.env.SUBMIT_STAFET_DELTAG_PAA_HOLD}`.replace(
                    '[pageId]',
                    store.state.main.page_id
                )
            const method = process.env.POSTMETHOD
            const fields = context.state.userInputs

            const deltagere = [...(getFieldValue(fields, 'deltagere') ?? [])]
            const childDeltagere = [
                ...(getFieldValue(fields, 'childDeltagere') ?? [])
            ]
            const isChild = getFieldValue(fields, 'isChild')

            const isFighter = getFieldValue(fields, 'isFighter')

            const body = {
                stafetKode: context.state.stafetId,
                holdKode: getFieldValue(fields, 'teamName') || null,
                paymentMethod: 'PaymentCard',
                invoiceAddress: {
                    firstName: getFieldValue(fields, 'firstName'),
                    lastName: getFieldValue(fields, 'lastName'),
                    phone: getFieldValue(fields, 'phone'),
                    email: getFieldValue(fields, 'email')
                },
                deltagere: deltagere,
                childDeltagere: childDeltagere,
                isChild: isChild,
                marketing: {
                    sflNewsletter: getFieldValue(fields, 'newsletter'),
                    fighterNewsletter: isFighter
                        ? getFieldValue(fields, 'fighterNewsletter')
                        : false
                }
            }

            const donationItems = getFieldValue(fields, 'donationItems')

            if (donationItems) {
                const donationFor = getFieldValue(fields, 'donationFor')
                const lysposer = {
                    amount: getFieldValue(fields, 'donationPerLightBag'),
                    supportSelectorSubmissionModel: {
                        supportStafet: donationFor === 'stafet',
                        supportHold: donationFor === 'team',
                        holdKode: getFieldValue(fields, 'donationTeam') || null,
                        supportDeltager: donationFor === 'participant',
                        deltagerId:
                            getFieldValue(fields, 'donationParticipant') || null
                    },
                    ownTextLysposer: getFieldValue(fields, 'addPersonalNote'),
                    lysposeSubmissionModels: donationItems
                }
                body['lysposer'] = lysposer
            }

            if (isFighter) {
                body['fighter'] = {
                    shirt: getFieldValue(fields, 'shirtSize'),
                    freeLunch: getFieldValue(fields, 'isFighterFreeLunch'),
                    firstTimeFighter: getFieldValue(fields, 'firstTimeFighter')
                }
            }

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(body)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med blevet tilføjet til et hold',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        },
        joinAsAFighterSubmit(context) {
            const url =
                `${document.location.origin}/${process.env.SUBMIT_STAFET_DELTAG_SOM_FIGHTER}`.replace(
                    '[pageId]',
                    store.state.main.page_id
                )
            const method = process.env.POSTMETHOD
            const fields = context.state.userInputs
            const joinATeam = getFieldValue(fields, 'joinATeam')
            const body = {
                stafetKode: context.state.stafetId,
                holdKode: joinATeam ? getFieldValue(fields, 'teamName') : null,
                paymentMethod: 'PaymentCard',
                invoiceAddress: {
                    firstName: getFieldValue(fields, 'firstName'),
                    lastName: getFieldValue(fields, 'lastName'),
                    phone: getFieldValue(fields, 'phone'),
                    email: getFieldValue(fields, 'email')
                },
                fighter: {
                    shirt: getFieldValue(fields, 'tshirtSize'),
                    freeLunch: getFieldValue(fields, 'participateInFreeLunch'),
                    firstTimeFighter: getFieldValue(fields, 'firstTimeFighter')
                },
                isChild: getFieldValue(fields, 'isChild'),
                marketing: {
                    fighterNewsletter: getFieldValue(
                        fields,
                        'fighterNewsletter'
                    ),
                    sflNewsletter: joinATeam
                        ? getFieldValue(fields, 'newsletter')
                        : false
                }
            }

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(body)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med blevet tilføjet til et hold',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        },
        addDeltagereSubmit(context, config) {
            const url =
                `${document.location.origin}/${process.env.SUBMIT_STAFET_ADD_DELTAGERE}`.replace(
                    '[pageId]',
                    store.state.main.page_id
                )
            const method = process.env.POSTMETHOD

            const body = getUserInputsBody(context.state.userInputs)
            body.stafetKode = config.stafetId
            body.holdKode = config.teamId
            body.paymentMethod = 'PaymentCard'
            body.invoiceAddress = config.userData

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(body)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med blevet tilføjet til et hold',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        },
        createTeamSubmit(context, config) {
            const pageId = store.state.main.page_id
            const sourceUrl = new URL(document.location.href)
            const previousHoldkode =
                sourceUrl.searchParams.get('previous-holdkode') ?? ''
            const relativeUrl = `${process.env.SUBMIT_STAFET_CREATE_HOLD.replace(
                '[pageId]',
                pageId
            )
                .replace('[stafetKode]', context.state.stafetId)
                .replace('[previousHoldkode]', previousHoldkode)}`
            const url = `${document.location.origin}/${relativeUrl}`
            const method = process.env.POSTMETHOD

            const data = getUserInputsBody(context.state.userInputs)

            const formdata = new FormData()
            formdata.append('teamName', data.teamName)
            formdata.append('description', data.description)
            if (data.logo) {
                formdata.append('image', data.logo[0])
            }
            formdata.append('slogan', data.slogan)
            formdata.append('donationGoal', data.donationGoal)
            formdata.append('firstName', data.firstName)
            formdata.append('lastName', data.lastName)
            formdata.append('email', data.email)
            formdata.append('phone', data.phone)
            formdata.append('newsletter', data.newsletter)

            const init = {
                method,
                body: formdata
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med oprettelsen af et hold',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        },
        editTeamSubmit(context, { stafetKode, holdKode }) {
            const pageId = store.state.main.page_id
            const relativeUrl = `${process.env.SUBMIT_STAFET_EDIT_HOLD.replace(
                '[pageId]',
                pageId
            ).replace('[holdKode]', holdKode)}`
            const url = `${document.location.origin}/${relativeUrl}`

            const method = process.env.PUTMETHOD

            const data = getUserInputsBody(context.state.userInputs)

            const formdata = new FormData()
            formdata.append('stafetKode', stafetKode)
            formdata.append('teamName', data.teamName)
            formdata.append('description', data.description)
            if (data.logo) {
                formdata.append('image', data.logo[0])
            }
            formdata.append('slogan', data.slogan)
            formdata.append('donationGoal', data.donationGoal)

            const headers = new Headers()
            const init = {
                headers,
                method,
                body: formdata
            }

            if (method !== 'PUT') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med opdatering af holdet',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        },
        submitCreateStafetProfile(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_STAFET_PROFILE_CREATE}`
            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(config)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((continueUrl) => {
                    sessionStorage.clear()
                    document.location.href = continueUrl
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med oprettelse af stafetprofil',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        },
        stafetProfileUpdatedSubmit(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_STAFET_PROFILE_UPDATED.replace('[stafetId]', context.state.stafetId)}`
            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(config.body)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med opdatering af stafetten',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        },
        submitDeleteStafetProfile(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_STAFET_PROFILE_DELETE.replace(
                '[pageId]',
                store.state.main.page_id
            )}`
            const method = process.env.DELETEMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(config.body)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med at slette stafet profilen',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        },
        submitUpdateStafetProfile(context, config) {
            const url = `${document.location.origin}/${process.env.SUBMIT_STAFET_PROFILE_UPDATED.replace(
                '[pageId]',
                store.state.main.page_id
            )}`
            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(config.body)
            }

            console.log(config.body)

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json
                })
                .catch((err) => {
                    console.error(
                        'Der skete en fejl med at opdatere stafet profilen',
                        err
                    )
                    context.commit('set_is_submitting', false)
                })
        }
    }
}

const getUserInputsBody = (userInputs) => {
    const body = {}
    userInputs.map((input) => {
        body[input.name] = input.value
    })

    return body
}
